import {
  type GenericMappingByKey,
  GenericMappingType,
} from '../../search/types'
import { getGenericMappingArrayFromGenericMappingByKey } from './utils'

export const GITLAB_GENERIC_MAPPINGS_BY_KEY = Object.freeze({
  iid: {
    type: GenericMappingType.KEYWORD,
    name: 'Identifier',
    description: 'Human readable MR/issue identifier',
    order: 0,
  },
  author: {
    type: GenericMappingType.KEYWORD,
    name: 'Author',
    description: 'Author of the MR/Issue',
    enumFromCollapseEsQuery: true,
    order: 1,
  },
  project: {
    type: GenericMappingType.KEYWORD,
    name: 'Project',
    description: 'Name of the GitLab project the MR/issue belongs to',
    enumFromCollapseEsQuery: true,
    order: 2,
  },
  state: {
    type: GenericMappingType.KEYWORD,
    name: 'State',
    description: 'State of the MR/issue',
    enumFromCollapseEsQuery: true,
    order: 3,
  },
  closedAt: {
    type: GenericMappingType.DATE,
    name: 'Closing date',
    description: 'Date when the MR/issue was closed (not the same as merged)',
    order: 4,
  },
  assignees: {
    type: GenericMappingType.KEYWORD,
    name: 'Assignees',
    description: 'Assignees responsible of the MR/issue',
    enumFromTermsAggEsQuery: true,
    order: 5,
  },
  labels: {
    type: GenericMappingType.KEYWORD,
    name: 'Labels',
    description: 'Labels set on the MR/issue',
    enumFromTermsAggEsQuery: true,
    order: 6,
  },
  milestone: {
    type: GenericMappingType.KEYWORD,
    name: 'Milestone',
    description: 'The milestone PR/issue is associated with',
    enumFromCollapseEsQuery: true,
    order: 7,
  },
  mergedAt: {
    type: GenericMappingType.DATE,
    name: 'Merge date',
    description: 'Date when the MR/issue was merged (not the same as closed)',
    order: 8,
  },
  mergedBy: {
    type: GenericMappingType.KEYWORD,
    name: 'Merged by',
    description: 'The user who merged the MR',
    order: 9,
  },
  type: {
    type: GenericMappingType.KEYWORD,
    name: 'Type',
    description: 'merge_request or issue',
    enum: ['issue', 'merge_request'],
    order: 10,
  },
  locked: {
    type: GenericMappingType.BOOLEAN,
    name: 'Locked',
    description: 'True if the MR/Issue is locked',
    order: 11,
  },
} satisfies GenericMappingByKey)

export const GITLAB_GENERIC_MAPPINGS =
  getGenericMappingArrayFromGenericMappingByKey(GITLAB_GENERIC_MAPPINGS_BY_KEY)
